var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageNextIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7489 12.5883C15.0837 12.2629 15.0837 11.7345 14.7489 11.4091L10.4642 7.24405C10.1294 6.91865 9.58581 6.91865 9.25106 7.24405C8.91631 7.56944 8.91631 8.09788 9.25106 8.42327L12.9306 12L9.25374 15.5767C8.91899 15.9021 8.91899 16.4306 9.25374 16.756C9.58848 17.0813 10.1321 17.0813 10.4669 16.756L14.7516 12.5909L14.7489 12.5883Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNextIco);
export default __webpack_public_path__ + "static/media/Page_next_ico.782881f9bd76dba39ecb0359a42aa703.svg";
export { ForwardRef as ReactComponent };